
import React, { } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import zhishi from "../../static/images/zhishi.jpg"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'2'} />
        <AboutTitle name={'知识产权'} english={'OWNERSHIP'}  />
        <div className='aboutImg'><img src={zhishi} /></div>
      </PageBox>
    </>
    
  );
}
